const SHARED_KEY = '7yr6227jxc5lh5j7u920j';

const textToBytes = (text) => new TextEncoder().encode(text);

const bytesToText = (bytes) => new TextDecoder().decode(bytes);

export const xorEncrypt = (text) => {
  const textBytes = textToBytes(text); 
  const keyBytes = textToBytes(SHARED_KEY); 

  const encryptedBytes = textBytes.map((byte, i) => byte ^ keyBytes[i % keyBytes.length]);
  return btoa(String.fromCharCode(...encryptedBytes));
};

export const xorDecrypt = (encoded) => {
  const encryptedStr = atob(encoded); 
  const encryptedBytes = Uint8Array.from(encryptedStr.split('').map(char => char.charCodeAt(0)));
  const keyBytes = textToBytes(SHARED_KEY);

  const decryptedBytes = encryptedBytes.map((byte, i) => byte ^ keyBytes[i % keyBytes.length]);
  return bytesToText(decryptedBytes);
};
